export interface ServerTiming {
  readonly appMs?: number;
  readonly starRocksMs?: number;
  readonly starRocksQueries?: number;
}

/** Reads the API's `app;dur=…, sr;dur=…;desc="N queries"` Server-Timing header. */
export const parseServerTiming = (header: string | null): ServerTiming => {
  if (!header) return {};
  const metrics = new Map<string, { dur?: number; desc?: string }>();
  header.split(',').forEach((entry) => {
    const [name, ...params] = entry.trim().split(';');
    const values: { dur?: number; desc?: string } = {};
    params.forEach((param) => {
      const [key, raw = ''] = param.trim().split('=');
      if (key === 'dur') {
        const dur = Number(raw);
        if (Number.isFinite(dur)) values.dur = dur;
      }
      if (key === 'desc') values.desc = raw.replace(/^"|"$/g, '');
    });
    metrics.set(name.trim(), values);
  });
  const queries = Number.parseInt(metrics.get('sr')?.desc ?? '', 10);
  return {
    appMs: metrics.get('app')?.dur,
    starRocksMs: metrics.get('sr')?.dur,
    starRocksQueries: Number.isNaN(queries) ? undefined : queries
  };
};
